import styled from "styled-components";

export const MenuItemStyled = styled.div`
  border-radius: 24px;
  padding-left: 25px;
  padding-right: 13px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  background: ${({ theme }) => theme.COLORS.PURPLE_1};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  .menu_item_row {
    display: flex;
    align-items: center;
    column-gap: 10px;
    white-space: nowrap;
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    color: ${({ theme }) => theme.COLORS.WHITE_1};
    .ct_icon_wrap {
      width: 24px;
    }
  }

  .theme_standard {
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    height: 44px;
  }
`;
